import { createAsyncThunk } from '@reduxjs/toolkit';
import { b2bThriftPlan } from '../../../../api/b2bThriftPlan';
import { PaginatedRequest } from '../../../../types/api';
import {
  FetchCompanyDepartmentsResponse,
  CreateCompanyDepartmentRequest,
  CreateCompanyDepartmentResponse,
  FetchCompanyDepartmentResponse,
  UpdateCompanyDepartmentRequest,
  UpdateCompanyDepartmentResponse,
  DeleteCompanyDepartmentResponse,
  RestoreCompanyDepartmentResponse,
} from '../../../../types/b2tRatibiPlus';

export const fetchCompanyDepartments = createAsyncThunk<
  FetchCompanyDepartmentsResponse,
  { companyId: number } & PaginatedRequest
>('companyDepartments/fetch-all', async (params) => {
  const response = await b2bThriftPlan.fetchCompanyDepartments(params);
  return response;
});

export const createCompanyDepartment = createAsyncThunk<
  CreateCompanyDepartmentResponse,
  { companyId: number; payload: CreateCompanyDepartmentRequest }
>('companyDepartments/create', async ({ companyId, payload }) => {
  const response = await b2bThriftPlan.createCompanyDepartment(companyId, payload);
  return response;
});

export const fetchCompanyDepartment = createAsyncThunk<
  FetchCompanyDepartmentResponse,
  { companyId: number; departmentId: number }
>('companyDepartments/fetch-one', async ({ companyId, departmentId }) => {
  const response = await b2bThriftPlan.fetchCompanyDepartment(companyId, departmentId);
  return response;
});

export const updateCompanyDepartment = createAsyncThunk<
  UpdateCompanyDepartmentResponse,
  { companyId: number; departmentId: number; payload: UpdateCompanyDepartmentRequest }
>('companyDepartments/update', async ({ companyId, departmentId, payload }) => {
  const response = await b2bThriftPlan.updateCompanyDepartment(companyId, departmentId, payload);
  return response;
});

export const deleteCompanyDepartment = createAsyncThunk<
  DeleteCompanyDepartmentResponse,
  { companyId: number; departmentId: number }
>('companyDepartments/delete', async ({ companyId, departmentId }) => {
  const response = await b2bThriftPlan.deleteCompanyDepartment(companyId, departmentId);
  return response;
});

export const restoreCompanyDepartment = createAsyncThunk<
  RestoreCompanyDepartmentResponse,
  { companyId: number; departmentId: number }
>('companyDepartments/restore', async ({ companyId, departmentId }) => {
  const response = await b2bThriftPlan.restoreCompanyDepartment(companyId, departmentId);
  return response;
});
